const Footer = () => {
  return (
      <footer>
        <p>
          Created by Accacia Benjamin, Michael Li, QiQi Liau, Shaurya Dubey at
          <a href="https://junocollege.com"> Juno College</a> © 2021.
        </p>
      </footer>
  );
};

export default Footer;
